<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Search Form
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <!-- ================= FILTER FORM ================= -->
                <v-form ref="bonusProcessForm" @submit.prevent="submit">
                  <v-row class="px-2 py-2" align="start" dense>
                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        variant="outlined"
                        label="From Date"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-inner-icon="mdi-calendar"
                        prepend-icon=""
                        clearable
                      ></v-date-input>
                    </v-col>
                     <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        variant="outlined"
                        label="To Date"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-inner-icon="mdi-calendar"
                        prepend-icon=""
                        clearable
                      ></v-date-input>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="process_date.value.value"
                        :error-messages="process_date.errorMessage.value"
                        variant="outlined"
                        label="Process Date"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-inner-icon="mdi-calendar"
                        prepend-icon=""
                        clearable
                      ></v-date-input>
                    </v-col>
                    <!-- Process Scope -->
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="process_scope.value.value"
                        :error-messages="process_scope.errorMessage.value"
                        variant="outlined"
                        label="Process Scope"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :loading="loading"
                        :items="getProcessScope"
                        item-title="label"
                        item-value="value"
                        prepend-inner-icon="mdi-format-list-bulleted"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <!-- Employee -->
                    <v-col v-if="employeeInput" cols="12" md="3">
                      <v-autocomplete
                        v-model="employee_id.value.value"
                        :error-messages="employee_id.errorMessage.value"
                        variant="outlined"
                        label="Employee"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :loading="loading"
                        :items="getHrmEmployeeList"
                        item-title="name"
                        item-value="id"
                        prepend-inner-icon="mdi-account"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <!-- Department -->
                    <v-col v-if="departmentInput" cols="12" md="3">
                      <v-autocomplete
                        v-model="department_id.value.value"
                        :error-messages="department_id.errorMessage.value"
                        variant="outlined"
                        label="Department"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :loading="loading"
                        :items="getHrmDepartmentList"
                        item-title="name"
                        item-value="id"
                        prepend-inner-icon="mdi-office-building"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <!-- Process Date -->
                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="process_date.value.value"
                        :error-messages="process_date.errorMessage.value"
                        
                        variant="outlined"
                        label="Process Date"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-inner-icon="mdi-calendar"
                        prepend-icon=""
                        clearable
                      ></v-date-input>
                    </v-col>

                    <!-- Bonus Percent -->
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="bonus_percent.value.value"
                        :error-messages="bonus_percent.errorMessage.value"
                        type="number"
                        variant="outlined"
                        label="Bonus Percent (%)"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-inner-icon="mdi-percent"
                        clearable
                      ></v-text-field>
                    </v-col>

                    <!-- Year -->
                    <v-col cols="12" md="2">
                      <v-autocomplete
                        v-model="year.value.value"
                        :error-messages="year.errorMessage.value"
                        :items="getYearList"
                        item-title="label"
                        item-value="value"
                        variant="outlined"
                        label="Year"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-month"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>
                    

                    <!-- Month -->
                    <v-col cols="12" md="2">
                      <v-autocomplete
                        v-model="month.value.value"
                        :error-messages="month.errorMessage.value"
                        :items="getMonthList"
                        item-title="label"
                        item-value="value"
                        variant="outlined"
                        label="Month"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-inner-icon="mdi-calendar-month"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="2" class="d-flex ga-2 align-center ">
                    <v-btn
                      color="primary"
                      variant="flat"
                      type="submit"
                      size="default"
                      height="40"
                      :loading="loading"
                    >
                      Search
                    </v-btn>
                  </v-col>
                  </v-row>

                  
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
            <v-expansion-panels v-model="panel1">
                <v-expansion-panel>
                <v-expansion-panel-title
                    color="blue-grey-lighten-4"
                    class="panel-header"
                >
                    Bonus Process List
                </v-expansion-panel-title>

                <v-expansion-panel-text>

                    <!-- =================== LIST DATATABLE ====================== -->
                    <v-data-table
                    :headers="tableHeaders"
                    :items="getBonusProcessList"
                    :loading="loading"
                    class="mt-6"
                    density="comfortable"
                    hover
                    >
                    <template #item.index="{ index }">
                        {{ index + 1 }}
                    </template>

                    <template #item.bonus_type="{ item }">
                        {{ item.bonus_type?.name }}
                    </template>

                    <template #item.month="{ item }">
                        {{ getMonthList.find(m => m.value == item.month)?.label ?? '-' }}
                    </template>

                    <template v-slot:item.approval_status_display="{ item }">
                      <v-chip
                      v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                      color="yellow-darken-3"
                      size="small"
                      >
                          Wating for {{ item.approval_current_process.approval_step_name.name }}
                      </v-chip>

                      <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                      color="green"
                      size="small"
                      >
                          Approved By {{ item.approval_current_process.approval_step_name.name }}
                      </v-chip>
                      
                      <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                      color="red"
                      size="small"
                      >
                          Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                      </v-chip>
                      <v-chip
                      v-else
                      color="green"
                      size="small"
                      >
                      {{ item.approval_status }}
                      </v-chip>
                    </template>

                    <!-- <template #item.actions="{ item }">
                        <v-btn
                        icon="mdi-eye"
                        color="primary"
                        size="small"
                        @click="viewDetails(item)"
                        ></v-btn>

                        <v-btn
                        icon="mdi-receipt-text"
                        color="green"
                        size="small"
                        @click="openChallanInfoModal(item)"
                        ></v-btn>
                    </template> -->

                    </v-data-table>
                </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  setup() {
    const store = useStore();
    const loading = ref(false);
    const panel = ref([0]);
    const panel1 = ref([0]);
    const employeeInput = ref(false);
    const departmentInput = ref(false);

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const process_scope = useField("process_scope");
    const department_id = useField("department_id");
    const employee_id = useField("employee_id");
    const process_date = useField("process_date");
    const bonus_percent = useField("bonus_percent");
    const year = useField("year");
    const month = useField("month");

    const { handleSubmit } = useForm({
      validationSchema: yup.object({}),
    });

    watch(
      () => process_scope.value.value,
      (v) => {
        employeeInput.value = v === "employee";
        departmentInput.value = v === "department";
      }
    );

    const submit = handleSubmit((values) => {
      loading.value = true;

      const payload = {
        process_scope: process_scope.value.value,
        department_id: department_id.value.value,
        employee_id: employee_id.value.value,
        process_date: formattedDate(process_date.value.value),
        from_date: formattedDate(from_date.value.value),
        to_date: formattedDate(to_date.value.value),
        bonus_percent: bonus_percent.value.value,
        year: year.value.value,
        month: month.value.value,
      };

      store
        .dispatch("getBonusProcessList", payload)
        .catch((err) => {
          toast.error(err.response?.data?.message || "Something went wrong");
        })
        .finally(() => {
          loading.value = false;
        });
    });

    const totalAmount = computed(() =>
      store.getters.getBonusProcessList?.reduce(
        (sum, item) => sum + Number(item.total_payable || 0),
        0
      )
    );

    return {
      panel,
      panel1,
      loading,
      process_scope,
      department_id,
      employee_id,
      employeeInput,
      departmentInput,
      process_date,
      from_date,
      to_date,
      bonus_percent,
      year,
      month,
      submit,
      totalAmount,
    };
  },

  computed: {
    getBonusTypeList() {
      return this.$store.getters.getBonusTypeList;
    },
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getBonusProcessList() {
      return this.$store.getters.getBonusProcessList;
    },
    getProcessScope() {
      return [
        { label: "All", value: "all" },
        { label: "Department", value: "department" },
        { label: "Employee", value: "employee" },
      ];
    },
    getMonthList() {
      return [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" },
      ];
    },
    getYearList() {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear - 5; i <= currentYear + 5; i++) {
            years.push(i);
        }
        return years;
    },
    tableHeaders() {
      return [
        { title: "#", key: "index", sortable: false },
        { title: "Bonus Type", key: "bonus_type" },
        { title: "Code", key: "code" },
        { title: "Process Date", key: "process_date" },
        { title: "Year", key: "year" },
        { title: "Month", key: "month" },
        { title: "Total Payable", key: "total_payable" },
        { title: 'Approval Status', key: 'approval_status_display', sortable: false, align: 'center', width: '100px' },
        // { title: "Action", key: "actions", sortable: false },
      ];
    },
  },

  created() {
    // if (this.$store.getters.getBonusTypeList.length === 0) {
      this.$store.dispatch("getBonusTypeList");
    // }
    // if (this.$store.getters.getHrmEmployeeList.length === 0) {
      this.$store.dispatch("getHrmEmployeeList");
    // }
    // if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    // }
    // if (this.$store.getters.getBonusProcessList.length === 0) {
      this.$store.dispatch("getBonusProcessList");
    // }
  },
};
</script>

<style scoped></style>
